import { produce } from 'immer';
import { actionTypes } from './constants';
import * as Types from './types';

export const defaultState: Types.ICommunicationWidgetsState = {
    isWidgetsAuthenticated: false
};

export const reducer = produce((
    draftState,
    action: Types.ISetIsWidgetsAuthenticatedAction
): Types.ICommunicationWidgetsState | void => {
    switch (action.type) {
        case actionTypes.SET_IS_WIDGETS_AUTHENTICATED: {
            Object.assign(draftState, {
                isWidgetsAuthenticated: action.payload
            });

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
